import React from "react";

export default function UpCopy2({ color = "#616161", ...restProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={8}
      height={14}
      viewBox="0 0 8 14"
      {...restProps}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M7.231 1.052l-5.274 5.68 5.273 5.664-.977 1.054L0 6.735 6.253 0z"
      />
    </svg>
  );
}
